import React from 'react';
import HeroImage from '../../../assets/images/services/banking-license/hero-image.png'
import PageBanner from '../../../assets/images/services/banking-license/page-banner.png'

import BreadCrumbs from "../../../components/BreadCrumbs/BreadCrumbs";
import HeroRightImage from "../../../components/Constant/HeroRightImage/HeroRightImage";
import BannerPageImg from "../../../components/Constant/Banner Page Img/BannerPageImg";
import PageList from "../../../components/Constant/List/List";
import { GiCheckMark } from "react-icons/gi";
import { GoDotFill } from "react-icons/go";
import Testimonials from "../../../components/Constant/Testimonials/Testimonials";
import CTA from "../../../components/Constant/cta/CTA";
import FAQList from "../../../components/Constant/FAQCard/FAQCard";
import Button from "../../../components/Constant/button/Button";

const BreadCrumbsData = [
    { name: 'Offshore Advisory', link: '/' },
    {
        name: 'Banking License – Mwali (Comoros)',
        link: '/banking-license-mwali',
    },
]

function BankingLicenseMwali () {

    return (
        <main className='main'>
            <section className='banking-license-section section'>
                <BreadCrumbs data={BreadCrumbsData}/>

                <div className='banking-license-container container'>

                    <h1 className='section-title'>
                        Banking License – Mwali (Comoros)
                    </h1>

                    <div className='grid-container'>
                        <div className='flex-start'>
                            <h3 className='page-subtitle'>
                                Establish a Bank in One of the Indian Ocean’s Leading Offshore Jurisdictions
                            </h3>
                            <p className='page-paragraph'>
                                <b>Mwali (Mohéli)</b>, part of the <b>Union of Comoros</b>, offers <b>internationally recognized offshore banking licenses</b> under the <b>Mwali International Services Authority (MISA)</b>. Known for <b>credibility</b> and <b>flexibility</b>, <b>Mwali</b> is a preferred choice for <b>investors seeking to establish international, private, or digital banks</b>.
                            </p>
                            <PageList
                                items={[
                                    {
                                        title: "International Bank License",
                                        icon: GoDotFill,
                                    },
                                    {
                                        title: "Private Banking",
                                        icon: GoDotFill,
                                    },
                                    {
                                        title: "Digital / Neo Banks",
                                        icon: GoDotFill,
                                    },
                                ]}
                            />
                            <Button
                                text="Request a Mwali Banking Proposal →"
                                link="/consultation"
                                type="primary"
                                size="large"
                            />
                        </div>

                        <HeroRightImage src={HeroImage} />
                    </div>

                    <BannerPageImg src={PageBanner} />
                    <b/><br/>

                    <div className='flex-start'>
                        <h3 className='page-title'>Why Choose Mwali for Banking?</h3>
                        <PageList
                            items={[
                                {
                                    title: "Global Recognition",
                                    paragraph: "Mwali banking licenses are widely accepted by PSPs and financial institutions",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Regulated by MISA",
                                    paragraph: "A reputable authority within the Comoros Union",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Multiple Banking Models",
                                    paragraph: "Commercial, private, digital, or investment-focused banks",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Access to Global Banking Networks",
                                    paragraph: "SWIFT/IBAN/SEPA integration possible",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Balanced Requirements",
                                    paragraph: "Lower capital than EU/Tier-1 regulators, but higher credibility than new offshore centers",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>
                            Types of Banking Licenses
                        </h3>
                        <h4 className='page-subtitle'>Class A – International Banking License</h4>
                        <p className='page-paragraph'>Allows full banking activities for international clients.</p>
                        <PageList
                            items={[
                                {
                                    paragraph: "Deposits, loans, and custody services",
                                    icon: GoDotFill,
                                },
                                {
                                    paragraph: "International transfers, remittance",
                                    icon: GoDotFill,
                                },
                                {
                                    paragraph: "Debit/credit card issuance",
                                    icon: GoDotFill,
                                },
                                {
                                    paragraph: "Private & corporate accounts",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h4 className='page-subtitle'>Class B – Private / Restricted Banking License</h4>
                        <p>For boutique/private banks targeting specific clients.</p>
                        <PageList
                            items={[
                                {
                                    paragraph: "Family offices & HNWIs",
                                    icon: GoDotFill,
                                },
                                {
                                    paragraph: "Wealth management & fiduciary services",
                                    icon: GoDotFill,
                                },
                                {
                                    paragraph: "Restricted clientele base (approved by MISA)",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h4 className='page-subtitle'>Digital / Neo Banking License</h4>
                        <p>For online-only fintech banks.</p>
                        <PageList
                            items={[
                                {
                                    paragraph: "E-wallets & mobile banking",
                                    icon: GoDotFill,
                                },
                                {
                                    paragraph: "Virtual IBANs & card issuing",
                                    icon: GoDotFill,
                                },
                                {
                                    paragraph: "API-driven banking solutions",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>Capital Requirements</h3>
                        <p>Mwali has <b>flexible capital requirements</b> compared to EU regulators.</p>
                        <PageList
                            items={[
                                {
                                    paragraph: "Typically USD 500,000–2,000,000, depending on license type & business model",
                                    icon: GoDotFill,
                                },
                                {
                                    paragraph: "Exact requirements are determined by MISA during the application review",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>Benefits of a Mwali Banking License</h3>
                        <PageList
                            items={[
                                {
                                    title: "Credibility & Acceptance",
                                    paragraph: "Stronger than emerging offshore regulators",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Faster Setup",
                                    paragraph: "2–3 weeks vs several years in Tier-1 jurisdictions",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Multi-Currency Services",
                                    paragraph: "USD, EUR, GBP, crypto-friendly add-ons",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "AML/KYC Frameworks",
                                    paragraph: "FATF-aligned compliance structures",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Scalable",
                                    paragraph: "Start as private/digital bank, expand to commercial banking later",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>Licensing Process</h3>
                        <PageList
                            items={[
                                {
                                    title: "Consultation & Planning",
                                    paragraph: "Determine banking model (commercial, private, digital)",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Company Incorporation",
                                    paragraph: "Set up IBC under Mwali jurisdiction",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Compliance Documentation",
                                    paragraph: "Business plan, AML/KYC policies, risk management",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Application Submission",
                                    paragraph: "Filed with MISA for review",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Approval & Activation",
                                    paragraph: "License granted, operations begin",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>Timeline & Costs</h3>
                        <PageList
                            items={[
                                {
                                    title: "Timeline",
                                    paragraph: "2–3 weeks (faster than EU/UK banking licenses)",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Setup Costs",
                                    paragraph: "From USD 20,000+ (depending on structure)",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Capital Requirements",
                                    paragraph: "Flexible, usually USD 500k–2M+",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Annual Renewals",
                                    paragraph: "Moderate vs other banking jurisdictions",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>Why Offshore Advisory?</h3>
                        <PageList
                            items={[
                                {
                                    title: "Recognized Agent with MISA Licensing Experience",
                                    paragraph: "",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "End-to-End Support",
                                    paragraph: "Incorporation, compliance, licensing, and SWIFT/IBAN onboarding",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Introductions to Banking Software Providers & PSPs",
                                    paragraph: "",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Guidance for Digital Banks & Fintech-Focused Banking Models",
                                    paragraph: "",
                                    icon: GoDotFill,
                                },
                            ]}
                        />



                    </div>

                    <FAQList data={faqData} title='Frequently Asked Questions (FAQ)'/>
                    <Testimonials
                        title="Client Testimonials"
                        testimonials={testimonialsData}
                    />
                    <CTA
                        title="Ready to start your own offshore bank?"
                        description="<b>Offshore Advisory</b> delivers <b>end-to-end support</b> for <b>Western Sahara Banking Licenses</b> under <b>CRA</b>, ensuring <b>full compliance</b> and <b>fast approvals</b>."
                        buttonText="Request Your Banking License Proposal →"
                        buttonLink="/consultation"
                    />

                </div>
            </section>


        </main>
    );
}

export default BankingLicenseMwali;

const faqData = [
    {
        question: "How recognized is a Mwali banking license?",
        content: [
            { type: "answer", text: "Mwali (Comoros) is a globally recognized offshore banking hub, respected more than newer jurisdictions like Anjouan or Western Sahara." },
        ],
    },
    {
        question: "How long does it take to obtain a license?",
        content: [
            { type: "answer", text: "Typically 2–3 Weeks, depending on documentation and review." },
        ],
    },
    {
        question: "Can I issue debit/credit cards?",
        content: [
            { type: "answer", text: "Yes — Mwali-licensed banks can partner with Visa/Mastercard providers." },
        ],
    },
    {
        question: "Can I launch a digital bank in Mwali?",
        content: [
            { type: "answer", text: "Yes — digital/neo banking models are supported." },
        ],
    },
    {
        question: "What compliance requirements apply?",
        content: [
            { type: "answer", text: "Mwali requires FATF-aligned AML/KYC frameworks, risk policies, and annual audits." },
        ],
    },
];

const testimonialsData = [
    {
        quote:
            "Offshore Advisory helped us obtain a banking license in Mwali within 9 months. Strong regulatory credibility and full PSP access.",
        author: "John D.",
        role: "Banking Investor",
    },
    {
        quote:
            "We structured a digital banking model under Mwali licensing with Offshore Advisory. Smooth and professional process.",
        author: "Elena S.",
        role: "FinTech Entrepreneur",
    },
];